import COLORS from './colors';

const typography = {
  fontFamily: 'Poppins, Arial, sans-serif',
  h1: {
    fontSize: 32,
    fontWeight: 600,
    color: COLORS.textColor
  },
  h2: {
    fontSize: 24,
    fontWeight: 500,
    color: COLORS.textSecondColor
  },
  h3: {
    fontSize: 18,
    fontWeight: 500,
    color: COLORS.textSecondColor
  },
  h4: {
    fontSize: 16,
    fontWeight: 500,
    color: COLORS.textSecondColor
  },
  h5: {
    fontSize: 14,
    fontWeight: 500,
    color: COLORS.textSecondColor
  },
  h6: {
    fontSize: 12,
    fontWeight: 500,
    color: COLORS.textSecondColor
  },
  body1: {
    fontSize: 14,
  },
  body2: {
    fontSize: 12,
  }
};

export default typography;
